import { render } from "./Import.vue?vue&type=template&id=4c7d87f6"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\Wizard Bridge EVM\\evm-token-bridge-fe-4 - สำเนา - สำเนา - Copy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__